<template>
    <div class="assignations-page">
        <div class="row">
            <div class="col-12 col-sm-6">
                <h4>Asignación</h4>
                <div>
                    <app-autocomplete
                        placeholder="Vigilantes-escoltas"
                        :items="vigilants"
                        v-model="selectedUser"
                        @change="$v.selectedUser.$touch()"
                    />
                    <!-- <app-autocomplete type="users" :exists="true" label="Seleccione el nombre de usuario" v-model="assignation.theUser" id="usuario-asignar"/>           -->
                </div>
                <div class="datos_usario" v-if="!!selectedUser">
                    <hr />
                    <div class="card">
                        <div class="card-header">
                            <h5>Información del usuario seleccionado</h5>
                        </div>
                        <div class="card-body">
                            <div class="card-text">
                                <div class="row">
                                    <div class="col-6 col-sm-4 col-md-3">
                                        <strong>Nombre: </strong>
                                    </div>
                                    <div class="col-6 col-sm col-md">
                                        {{ selectedUser.name }}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 col-sm-4 col-md-3">
                                        <strong>Documento: </strong>
                                    </div>
                                    <div class="col-6 col-sm col-md">
                                        {{ selectedUser.document }}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 col-sm-4 col-md-3">
                                        <strong>Perfil: </strong>
                                    </div>
                                    <div class="col-6 col-sm col-md">
                                        {{ selectedUser.profile.name }}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 col-sm-4 col-md-3">
                                        <strong>Email: </strong>
                                    </div>
                                    <div class="col-6 col-sm col-md">
                                        {{ selectedUser.email }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6" v-if="selectedUser">
                <b-container fluid>
                    <b-row>
                        <b-col>
                            <app-autocomplete
                                label="Cliente"
                                :items="clients"
                                v-model="selectedClient"
                                :has-error="$v.selectedClient.$error"
                                error-message="Debe seleccionar el cliente"
                                @input="onClientChange"
                            />
                        </b-col>
                    </b-row>
                    <b-row v-if="accessPoints.length > 0">
                        <b-col>
                            <app-sub-title
                                text="Asignación de puestos de vigilancia"
                            ></app-sub-title>
                            <app-data-table
                                :items="accessPoints"
                                :fields="accessPointsFields"
                            >
                                <template slot="actions" slot-scope="{ item }">
                                    <b-checkbox
                                        v-model="assignation.accessPoints"
                                        :value="item.id"
                                    ></b-checkbox>
                                </template>
                            </app-data-table>
                        </b-col>
                    </b-row>
                </b-container>

                <div
                    class="text-right my-3"
                    v-if="!!selectedClient && !!selectedUser"
                >
                    <button class="btn btn-secondary" @click="clean">
                        <i class="fa fa-undo" aria-hidden="true"></i> Asignar
                        otro usuario
                    </button>
                    <b-btn
                        variant="confirm"
                        @click="saveAssignations"
                        :disabled="inProgress"
                    >
                        <i class="fa fa-save"></i> Guardar Asignación
                    </b-btn>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AutoComplete from '../../UI/Controls/AutocompleteV2/Autocomplete.vue'
import FormSelectInput from '../../UI/Controls/Forms/FormSelectInput.vue'
import DateTimePicker from '../../UI/Controls/DateTimePicker/DateTimePicker.vue'
import usersRepository from '../../../repositories/users.repository'
import structuresRepository from '../../../repositories/structures.repository'
import roundsRepository from '@repositories/rounds.repository'
import { required, email, numeric } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
export default {
    components: {
        // appAutocomplete: AutoComplete,
        appFormSelectInput: FormSelectInput,
        appDateTimePicker: DateTimePicker,
    },
    data() {
        return {
            assignation: {
                validityDate: null,
                accessPoints: [],
            },
            selectedClient: '',
            selectedUser: '',
            assignations: [],
            structures: [],
            vigilants: [],
            rounds: [],
            accessPointsFields: [
                {
                    key: 'name',
                    label: 'Nombre',
                    sortable: false,
                },
                {
                    key: 'structure_type.name',
                    label: 'Tipo',
                    sortable: false,
                },
                {
                    key: 'venue.name',
                    label: 'Sede',
                    sortable: false,
                },
                {
                    key: 'actions',
                    label: 'Selección',
                    sortable: false,
                },
            ],
        }
    },

    validations: {
        selectedClient: { required },
        selectedUser: { required },
    },
    computed: {
        // ...mapGetters(['selectedUser', 'clients']),
        ...mapGetters(['clients']),
        accessPoints() {
            if (!this.selectedClient) return []

            const accessPoints = this.structures.filter(
                structure => !!structure.structure_type.access_point
            )

            return accessPoints
        },
        accessPointsNotAssigned() {
            const notAssigned = this.accessPoints.filter(
                item =>
                    !this.assignations
                        .map(assignation => assignation.structure_id)
                        .includes(item.id)
            )
            return notAssigned.map(item => ({
                ...item,
                name: `${item.name} (${item.venue.name})`,
            }))
        },
    },
    methods: {
        onClientChange() {
            this.$v.selectedClient.$touch()
            this.assignation.accessPoints = []
            this.loads()
        },
        loads() {
            this.loadStructures()
            this.loadAssignations(this.selectedUser, this.selectedClient.id)
            // this.loadRounds();
        },
        loadVigilants() {
            const ur = {
                ...usersRepository,
            }
            ur.getOperatives()
                .then(data => {
                    // this.vigilants = data;
                    data.map(item => {
                        const operative = {
                            ...item,
                            name: item.name + ' (' + item.username + ')',
                        }
                        this.vigilants.push(operative)
                    })
                })
                .catch(error =>
                    toastr.error(
                        'Ocurrio un error al cargar los vigilantes y escoltas'
                    )
                )
        },
        loadStructures() {
            if (!this.selectedClient) {
                toastr.warning('Seleccione el cliente')
            } else {
                const sr = Object.assign({}, structuresRepository)
                sr.all(this.selectedClient.id)
                    .then(data => {
                        this.structures = data
                    })
                    .catch(error =>
                        toastr.error(
                            'Ocurrio un error al cargar las estructuras del cliente'
                        )
                    )
            }
        },
        async loadAssignations(user, clientId) {
            if (!user || !clientId)
                return toastr.error(
                    'Ocurrió un error al cargar las asignaciones'
                )
            const theClient = this.selectedClient
            const ur = Object.assign({}, usersRepository)
            try {
                const { assignations } = await ur.assignationsUser(
                    user,
                    clientId
                )
                this.assignations = assignations
                this.assignation.accessPoints = []
                assignations.map(
                    item =>
                        this.selectedClient.id === item.structure.client_id &&
                        this.assignation.accessPoints.push(item.structure_id)
                )
            } catch (err) {
                this.handleErrors(err)
            }
        },
        saveAssignation() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }
            const payload = {
                userId: this.assignation.theUser.id,
                dateValidate: this.assignation.validityDate,
                structureId: this.assignation.structureId,
                assignedBy: this.user.id,
            }
            const ur = Object.assign({}, usersRepository)
            ur.assignationToUser(payload)
                .then(data => {
                    toastr.success('Asignación guardada')
                    this.loadAssignations(
                        this.assignation.theUser,
                        this.assignation.client.id
                    )
                    this.assignation.validityDate = null
                    this.assignation.structureId = ''
                    this.$bus.$emit('due-date.clear')
                    this.$v.$reset()
                })
                .catch(error => this.handleErrors(error))
        },
        async saveAssignations() {
            this.$v.$touch()
            if (this.$v.$invalid)
                return toastr.error(
                    'Debe diligenciar todos los datos correctamente'
                )

            const ur = { ...usersRepository }
            try {
                const payload = {
                    ...this.assignation,
                    userId: this.selectedUser.id,
                    clientId: this.selectedClient.id,
                    assignedById: this.user.id,
                }
                const { data } = await ur.saveAssignations(payload)

                if (data.status) {
                    toastr.success(data.msg)
                } else {
                    toastr.error(data.msg)
                }
            } catch (err) {
                toastr.error(err.message)
            }
        },
        removeAssignation(theAssignation) {
            const ur = Object.assign({}, usersRepository)
            ur.removeAssignation(theAssignation.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.loadAssignations(
                            this.assignation.theUser,
                            this.assignation.client.id
                        )
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('No se pudo borrar el usuario')
                })
        },
        clean() {
            this.assignation.theUser = ''
            this.assignation.client = ''
            this.assignations = []
            this.structures = []
            this.$bus.$emit('due-date.clear')
        },
        initializeUser() {
            if (!!this.selectedUser) {
                this.assignation.theUser = Object.assign({}, this.selectedUser)
                this.$store.commit('selectedUser', null)
            }
        },
        async loadRounds() {
            const rr = { ...roundsRepository }

            try {
                const clientId = this.selectedClient.id

                const { data } = await rr.get({ clientId })

                this.rounds = data
            } catch (err) {
                toastr.error(err.message)
            }
        },
        getDay(d) {
            const days = {
                0: 'dom',
                1: 'lun',
                2: 'mar',
                3: 'mie',
                4: 'jue',
                5: 'vie',
                6: 'sab',
            }

            return days[d.day]
        },
    },

    created() {
        this.load('clients')
        this.initializeUser()
        this.loadVigilants()
    },
}
</script>
<style scoped>
.add-button {
    display: flex;
    flex-direction: row;
}

.add-button__button {
    flex: 0 0 100%;
    align-self: flex-end;
}
</style>
